/**
 * Cooking operations (process.md): the cooking stages of a Preparation (bake-session.md) and the
 * heat steps that end the fermentation (fermentation.md). `preheat` heats equipment, not the
 * dough; a `proof` held in an oven's Proof mode is fermentation, whatever the appliance.
 */
export const COOKING_OPERATIONS = [
    'bake',
    'boil',
    'steam',
    'fry',
    'panCook',
    'grill',
];
export const isCookingStep = (step) => COOKING_OPERATIONS.includes(step.operation);
export const OUTCOME_RESULTS = [
    'cooked',
    'dough',
    'cookedAndDough',
];
export const DOUGH_DISPOSITIONS = [
    'frozen',
    'refrigerated',
    'given',
    'sold',
    'other',
];
/** Why an outcome is invalid, as `{ field, reason }`, or undefined when it is valid. */
export const outcomeProblem = (outcome) => {
    if (!OUTCOME_RESULTS.includes(outcome.result)) {
        return { field: 'result', reason: 'must be cooked, dough or cookedAndDough' };
    }
    const keepsDough = outcome.result !== 'cooked';
    if (outcome.dough !== undefined) {
        if (!keepsDough)
            return { field: 'dough', reason: 'only with a dough result' };
        if (!DOUGH_DISPOSITIONS.includes(outcome.dough)) {
            return { field: 'dough', reason: 'unknown disposition' };
        }
    }
    if (outcome.pieces !== undefined) {
        if (!keepsDough)
            return { field: 'pieces', reason: 'only with a dough result' };
        if (!(Number.isInteger(outcome.pieces) && outcome.pieces >= 1)) {
            return { field: 'pieces', reason: 'must be an integer ≥ 1' };
        }
    }
    return undefined;
};
/**
 * The outcome a recipe ends with (bake-session.md): its own `intendedOutcome`, else `cooked` when
 * the process has a cooking step, else a raw `dough` with no disposition.
 */
export const intendedOutcome = (process) => process.intendedOutcome ??
    (process.steps.some(isCookingStep) ? { result: 'cooked' } : { result: 'dough' });
//# sourceMappingURL=cooking.js.map